import { render, staticRenderFns } from "./ClinicAllergyDic.vue?vue&type=template&id=5907e1a4"
import script from "./ClinicAllergyDic.vue?vue&type=script&lang=js"
export * from "./ClinicAllergyDic.vue?vue&type=script&lang=js"
import style0 from "./ClinicAllergyDic.vue?vue&type=style&index=0&id=5907e1a4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5907e1a4')) {
      api.createRecord('5907e1a4', component.options)
    } else {
      api.reload('5907e1a4', component.options)
    }
    module.hot.accept("./ClinicAllergyDic.vue?vue&type=template&id=5907e1a4", function () {
      api.rerender('5907e1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicAllergyDic.vue"
export default component.exports